(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-store-photos]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const items = [...gallery.querySelectorAll('[data-store-photo]')];
      const dialog = gallery.querySelector('[data-store-dialog]');
      const full = dialog.querySelector('[data-store-full]');
      let index = 0;
      let opener;
      const show = next => {
        index = (next + items.length) % items.length;
        const item = items[index];
        full.src = item.href;
        full.alt = item.querySelector('img').alt;
        dialog.querySelector('[data-store-caption]').textContent = item.dataset.caption;
        dialog.querySelector('[data-store-photo-count]').textContent = `${index + 1} / ${items.length}`;
      };
      const open = (next, target) => {
        opener = target;
        show(next);
        dialog.showModal();
        document.body.classList.add('diana-store-gallery-open');
        dialog.querySelector('[data-store-close]').focus();
      };
      items.forEach((item,i) => item.addEventListener('click', event => {
        event.preventDefault(); open(i,item);
      }));
      gallery.querySelector('[data-open-store-gallery]')?.addEventListener('click', event => open(0,event.currentTarget));
      dialog.querySelector('[data-store-close]').addEventListener('click', () => dialog.close());
      dialog.querySelector('[data-store-prev]').addEventListener('click', () => show(index-1));
      dialog.querySelector('[data-store-next]').addEventListener('click', () => show(index+1));
      dialog.addEventListener('keydown', event => {
        if (event.key === 'Tab') {
          const buttons = [...dialog.querySelectorAll('button:not(:disabled)')];
          const first = buttons[0];
          const last = buttons[buttons.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); show(index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        document.body.classList.remove('diana-store-gallery-open');
        opener?.focus();
      });
      let touch;
      full.addEventListener('touchstart', event => { touch = event.changedTouches[0]; }, {passive:true});
      full.addEventListener('touchend', event => {
        if (!touch) return;
        const end = event.changedTouches[0];
        if (Math.abs(end.clientX-touch.clientX)>50 && Math.abs(end.clientY-touch.clientY)<70) show(index+(end.clientX<touch.clientX?1:-1));
        touch = null;
      }, {passive:true});
    });

    const familyMenus = [...document.querySelectorAll('[data-family]')];
    familyMenus.forEach(menu => {
      const container = menu.querySelector('.diana-nav-menu');
      [...container.querySelectorAll('a:not(.diana-nav-menu__featured)')]
        .sort((a,b)=>a.textContent.localeCompare(b.textContent,'es',{sensitivity:'base'}))
        .forEach(link=>container.append(link));
    });
    const familySelect = root.querySelector('#CatalogFamily');
    if (familySelect) {
      const directory = root.querySelector('.diana-category-directory__grid');
      const cards = [...directory.querySelectorAll('[data-collection]')];
      cards.sort((a,b)=>a.textContent.trim().localeCompare(b.textContent.trim(),'es',{sensitivity:'base'})).forEach(card=>directory.append(card));
      const applyFamily = () => {
        const family = new URL(location.href).searchParams.get('familia') || '';
        const menu = familyMenus.find(item=>item.dataset.family === family);
        const paths = menu ? new Set([...menu.querySelectorAll('a:not(.diana-nav-menu__featured)')].map(a=>new URL(a.href).pathname)) : null;
        familySelect.value = menu ? family : '';
        root.querySelector('[data-family-title]').textContent = menu ? familySelect.selectedOptions[0].textContent : 'Todas las categorías';
        cards.forEach(card=>{card.hidden = !!paths && !paths.has(new URL(card.href).pathname);});
      };
      applyFamily();
      familySelect.form.addEventListener('submit', event => {
        event.preventDefault();
        const url = new URL(location.href);
        if (familySelect.value) url.searchParams.set('familia',familySelect.value); else url.searchParams.delete('familia');
        history.pushState({},'',url); applyFamily();
      });
      window.addEventListener('popstate',applyFamily);
    }
    root.querySelectorAll('[data-catalog-filter-form]').forEach(form=>{
      const min = form.elements.namedItem('filter.v.price.gte');
      const max = form.elements.namedItem('filter.v.price.lte');
      const validate = () => {
        if (max) max.setCustomValidity(min?.value !== '' && max.value !== '' && Number(min.value)>Number(max.value) ? 'El precio máximo debe ser mayor o igual al mínimo.' : '');
      };
      min?.addEventListener('input',validate); max?.addEventListener('input',validate);
      form.addEventListener('formdata', event => {
        for (const [name,value] of [...event.formData.entries()]) {
          if (name.startsWith('filter.v.price.') && value === '') event.formData.delete(name);
        }
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
